<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>プライススクリーニング STEP<span>01</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>取り扱い商品のジャンル登録</span></h3>
                <p>プライススクリーニングに使用するジャンルを1つ選択してください。</p>
            </div>

            <!--item-->
            <div class="item-wrap form_radio-text">
                <div class="item">
                    <div class="item form_radio _big" v-for="(categoriyLv1,index) in categoriyLv1List" v-bind:key="index">
                        <input type="radio" name="categoriyLv1-radio" :id="'categoriyLv1-radio' + index" v-on:change="changeLv1(categoriyLv1)">
                        <label :for="'categoriyLv1-radio' + index"><span>{{ categoriyLv1.name }}</span></label>
                    </div>
                </div>
            </div>
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev" v-on:click="swiperBack1()"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next"  v-bind:disabled="isDisabled"><span>Next</span></button>
        </div>

    </div>
</div>
</template>


<script>
    export default {
        data() {
            return {
                isDisabled: false,
            }
        },
        computed: {
            categoriyLv1List (){
                return this.$store.state.register.form.Lv1;
            }
        },
        mounted() {
            this.isDisabled = true;
        },
        methods: {
            changeLv1 (categoriyLv1) {
                this.$store.state.register.form.select_priceZone_categoriyLv1 = categoriyLv1;
                this.isDisabled = false;
            },
            swiperBack1() {
                var name = 'input[name=categoriyLv1-radio]';
                $(name).prop('checked', false);
                this.$store.state.register.form.select_priceZone_categoriyLv1 = [];
                this.isDisabled = true;
            }
        }
    }
</script>